<template>
  <div class="structured-wrapper container">
    <section class="structured-container">
      <router-view />
    </section>
  </div>
</template>
